"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iframeAppBiLoggerFactory = void 0;
var web_bi_logger_1 = require("@wix/web-bi-logger");
var iframe_app_bi_context_1 = require("@wix/iframe-app-bi-context");
function iframeAppBiLoggerFactory(Wix, options) {
    if (options === void 0) { options = {}; }
    var factory = web_bi_logger_1.default.factory(__assign(__assign({}, options), { trackSession: false }));
    factory.updateDefaults((0, iframe_app_bi_context_1.getBiContext)(Wix));
    return factory;
}
exports.iframeAppBiLoggerFactory = iframeAppBiLoggerFactory;
//# sourceMappingURL=index.js.map